import {
  aesEncrypt,
  createSignedDataString,
  getHash,
  type Cipher,
} from '@pw-spk/general-app-web-cryptography';

import { readFile } from '../file/file.util';

import type { IEncryptFileReturn } from './encryption.util.type';

export const encryptFile = async (cipher: Cipher, file: File): Promise<IEncryptFileReturn> => {
  const fileBytes = await readFile(file);

  const { encryptedData, nonce } = aesEncrypt(cipher, fileBytes);
  const hash = getHash(fileBytes);
  const encryptedDataHash = getHash(encryptedData);

  return {
    // Normally this is where the signature goes, but we don't have a private key
    hash: createSignedDataString(hash, 'NOSIGN'),
    encryptedHash: createSignedDataString(encryptedDataHash, 'NOSIGN'),
    size: file.size,
    encryptedData,
    nonce,
    name: file.name,
  };
};
